import {
  IPartnerFormAdditionalLinksBlock,
  IPartnerFormAdditionalSocialBlock,
} from 'clickNgo/entities/partner/models/form/additional'
import {
  IPartnerFormBasicAddressBlock,
  IPartnerFormBasicCommonBlock,
  IPartnerFormBasicHierarchyBlock,
} from 'clickNgo/entities/partner/models/form/basic'
import { IPartnerFormSettings } from 'clickNgo/entities/partner/models/form/common'
import {
  IPartnerFormLegalAddressBlock,
  IPartnerFormLegalCommonBlock,
} from 'clickNgo/entities/partner/models/form/legal'
import { IPartner } from 'clickNgo/entities/partner/models/partner'
import { I406Form } from 'clickNgo/models/crud/forms/i406Form'
import { I502Form } from 'clickNgo/models/crud/forms/i502Form'
import { TFieldsConfig } from 'clickNgo/models/widget'

export const PartnerFields: TFieldsConfig<
  IPartnerFormBasicHierarchyBlock & Pick<IPartner, 'parentPartnerId' | 'partnerId'>,
  I406Form
> &
  TFieldsConfig<IPartnerFormBasicCommonBlock, I406Form> &
  TFieldsConfig<IPartnerFormBasicAddressBlock, I406Form> &
  TFieldsConfig<
    IPartnerFormLegalCommonBlock & Pick<IPartnerFormSettings, 'doCopyBasicName'>,
    I502Form
  > &
  TFieldsConfig<
    IPartnerFormLegalAddressBlock & Pick<IPartnerFormSettings, 'doCopyBasicAddress'>,
    I502Form
  > &
  TFieldsConfig<IPartnerFormAdditionalSocialBlock> &
  TFieldsConfig<IPartnerFormAdditionalLinksBlock> = {
  hierarchyType: {
    externalField: 'Hierarchy',
    field: 'hierarchyType',
    label: 'partnerinfo-content-fieldlabels-hierarchy_type',
  },
  topPartnerId: {
    externalField: 'TopPartnerID',
    field: 'topPartnerId',
    label: 'partnerinfo-content-fieldlabels-top_partner_id',
  },
  parentPartnerId: {
    externalField: 'TopPartnerID',
    field: 'parentPartnerId',
    label: 'partnerinfo-content-fieldlabels-parent_partner_id',
  },
  partnerId: {
    externalField: 'PartnerID',
    field: 'partnerId',
    label: 'partnerinfo-content-fieldlabels-partner_id',
  },
  communicationName: {
    externalField: 'CommunicationName',
    field: 'communicationName',
    label: 'partnerinfo-content-fieldlabels-communication_name',
  },
  email: {
    externalField: 'Email',
    field: 'email',
    label: 'partnerinfo-content-fieldlabels-email',
  },
  taxId: {
    externalField: 'TaxID',
    field: 'taxId',
    label: 'partnerinfo-content-fieldlabels-tax_id',
  },
  url: {
    externalField: 'URL',
    field: 'url',
    label: 'partnerinfo-content-fieldlabels-url',
  },
  phone: {
    externalField: 'MainPhone',
    field: 'phone',
    label: 'partnerinfo-content-fieldlabels-phone',
  },
  phoneCountryCode: {
    externalField: 'MainPhoneCountryCode',
    field: 'phoneCountryCode',
    label: 'partnerinfo-content-fieldlabels-phone_country_code',
  },
  storeNumber: {
    externalField: 'StoreNumber',
    field: 'storeNumber',
    label: 'partnerinfo-content-fieldlabels-store_number',
  },
  addressLine1: {
    externalField: 'AddressLine1',
    field: 'addressLine1',
    label: 'partnerinfo-content-fieldlabels-address_line_1',
  },
  addressLine2: {
    externalField: 'AddressLine2',
    field: 'addressLine2',
    label: 'partnerinfo-content-fieldlabels-address_line_2',
  },
  addressLine3: {
    externalField: 'AddressLine3',
    field: 'addressLine3',
    label: 'partnerinfo-content-fieldlabels-address_line_3',
  },
  country: {
    externalField: 'Country',
    field: 'country',
    label: 'partnerinfo-content-fieldlabels-country',
  },
  countryCode: {
    field: 'countryCode',
    label: 'partnerinfo-content-fieldlabels-country_code',
  },
  state: {
    externalField: 'State',
    field: 'state',
    label: 'partnerinfo-content-fieldlabels-state',
  },
  city: {
    externalField: 'City',
    field: 'city',
    label: 'partnerinfo-content-fieldlabels-city',
  },
  zipCode: {
    externalField: 'ZIPCode',
    field: 'zipCode',
    label: 'partnerinfo-content-fieldlabels-zip_code',
  },
  // LEGAL INFO
  doCopyBasicName: {
    field: 'doCopyBasicName',
    label: 'partnerinfo-content-fieldlabels-do_copy_basic_name',
  },
  companyLegalName: {
    externalField: 'CompanyLegalName',
    field: 'companyLegalName',
    label: 'partnerinfo-content-fieldlabels-company_legal_name',
  },
  companyLegalNameNonLatin: {
    externalField: 'CompanyLegalNameNonLatin',
    field: 'companyLegalNameNonLatin',
    label: 'partnerinfo-content-fieldlabels-company_legal_name_non_latin',
  },
  companyEnglishName: {
    externalField: 'CompanyEnglishName',
    field: 'companyEnglishName',
    label: 'partnerinfo-content-fieldlabels-company_english_name',
  },
  doCopyBasicAddress: {
    field: 'doCopyBasicAddress',
    label: 'partnerinfo-content-fieldlabels-do_copy_basic_address',
  },
  legalAddressLine1: {
    externalField: 'LegalAddr1',
    field: 'legalAddressLine1',
    label: 'partnerinfo-content-fieldlabels-legal_address_line_1',
  },
  locationId: {
    externalField: 'LocationID',
    field: 'locationId',
    label: 'partnerinfo-content-fieldlabels-location_id',
  },
  legalAddressLine2: {
    externalField: 'LegalAddr2',
    field: 'legalAddressLine2',
    label: 'partnerinfo-content-fieldlabels-legal_address_line_2',
  },
  legalAddressLine3: {
    externalField: 'LegalAddr3',
    field: 'legalAddressLine3',
    label: 'partnerinfo-content-fieldlabels-legal_address_line_3',
  },
  legalCountry: {
    externalField: 'LegalCountry',
    field: 'legalCountry',
    label: 'partnerinfo-content-fieldlabels-legal_country',
  },
  legalCity: {
    externalField: 'LegalCity',
    field: 'legalCity',
    label: 'partnerinfo-content-fieldlabels-legal_city',
  },
  legalState: {
    externalField: 'LegalState',
    field: 'legalState',
    label: 'partnerinfo-content-fieldlabels-legal_state',
  },
  legalZipCode: {
    externalField: 'LegalPostalCode',
    field: 'legalZipCode',
    label: 'partnerinfo-content-fieldlabels-legal_zip_code',
  },
  facebookLink: {
    field: 'facebookLink',
    label: 'partnerinfo-content-fieldlabels-facebook_link',
  },
  linkedInLink: {
    field: 'linkedInLink',
    label: 'partnerinfo-content-fieldlabels-linken_in_link',
  },
  twitterLink: {
    field: 'twitterLink',
    label: 'partnerinfo-content-fieldlabels-twitter_link',
  },
  whatsAppLink: {
    field: 'whatsAppLink',
    label: 'partnerinfo-content-fieldlabels-whats_app_link',
  },
  hasNotOnlineCommerce: {
    field: 'hasNotOnlineCommerce',
    label: 'partnerinfo-content-fieldlabels-has_not_online_commerce',
  },
  ecommerceLinks: {
    field: 'ecommerceLinks',
    label: 'partnerinfo-content-fieldlabels-ecommerce_links',
  },
  socialMediaLinks: {
    field: 'socialMediaLinks',
    label: 'partnerinfo-content-fieldlabels-social_media_links',
  },
  market: {
    field: 'market',
    label: 'partnerinfo-content-fieldlabels-market',
  },
  region: {
    field: 'region',
    label: 'partnerinfo-content-fieldlabels-region',
  },
}
